import ChannelSelect from "@components/channel/components/ChannelSelect";
import StoreSelect from "@components/store/components/StoreSelect";
import UserSelect from "@components/user/components/UserSelect";
import {
  EVENT_VISIBILITY_STATUSES,
  INVENTORY_EVENT_STATUSES,
} from "@constants/inventory-control-event";
import { Select } from "d-react-components";
import { map } from "lodash";
import { useTranslation } from "react-i18next";

interface IInventoryFilterForm {
  filterForm: any;
}

const InventoryEventFilterForm = ({ filterForm }: IInventoryFilterForm) => {
  const classNameField = "col-span-12 mt-3";
  const formValues = filterForm?.values;
  const formErrors = filterForm?.errors;
  const { t } = useTranslation();

  return (
    <div>
      <div className="grid grid-cols-4 gap-4">
        <ChannelSelect
          value={formValues.channels}
          className={classNameField}
          onChange={(value) =>
            filterForm.setValues({
              ...formValues,
              channels: value,
              warehouses: [],
            })
          }
          multiple
        />
        <StoreSelect
          className={classNameField}
          value={formValues.warehouses}
          onChange={(value: any) => {
            filterForm.setValues({
              ...formValues,
              warehouses: value,
            });
          }}
          channelId={map(formValues.channels, (item) => item.id)}
          multiple
        />
        <Select
          label={t("status")}
          className={classNameField}
          value={formValues?.status}
          onChange={(value) => {
            filterForm.setFieldValue("status", value);
          }}
          getLabel={(item) => t(item?.label)}
          dataSource={INVENTORY_EVENT_STATUSES}
          multiple
        />
        <Select
          label={t("visibility")}
          className={classNameField}
          value={formValues?.visibility}
          onChange={(value) => {
            filterForm.setFieldValue("visibility", value);
          }}
          getLabel={(item) => t(item?.label)}
          dataSource={EVENT_VISIBILITY_STATUSES}
        />
        <UserSelect
          label={t("createdBy")}
          className={classNameField}
          value={formValues?.createdBy}
          onChange={(value) => {
            filterForm.setFieldValue("createdBy", value);
          }}
          multiple
        />
      </div>
    </div>
  );
};

export default InventoryEventFilterForm;
